var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"footer mt-auto py-3 bg-dark fixed-bottom mt-5 d-md-none"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }